import React, {useEffect, useState} from 'react';
import GiftSVG from '../../../assets/img/gift.svg'
import {useLocation, useNavigate} from "react-router-dom";
import Timer from "./Timer";
import {useDispatch, useSelector} from "react-redux";
import {eventsList, showEventResult} from "./eventSlice";
import {Tooltip} from "@mui/material";
import Loader from "../../subsidiary/Loader/Loader";

const NewYearEvent = (props) => {
    const eventFinished = props.props?.eventFinished
    const ref = props.props?.ref
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const events = useSelector(state => state.eventSlice.events[0])
    const loading = useSelector(state => state.eventSlice.eventLoading)
    const isEventFinished = useSelector(state => state.eventSlice.events[0]?.isFinish)
    const EventId = localStorage.getItem('user_number')
    const [showTable, setShowTable] = useState(false)
    const handleShowRes = () => {
        dispatch(showEventResult())
        if (eventFinished) {
            ref.current.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
    }

    useEffect(() => {
        dispatch(eventsList(token))
    }, [])
    return (
        <>
            {!events ? '' :
                <div className='event-wrapper'
                     style={{boxShadow: '0 0 19px 2px #DADADA'}}>
                    <div className={'event-content'}>
                        <h1 className='event-title'>{events?.name}</h1>
                        <p className='event-subtitle' dangerouslySetInnerHTML={{__html: events.description}}></p>
                        <div className='event-subcontent'>
                            {events && !isEventFinished && <>
                                <span className='event-timer_title'>До розыгрыша осталось</span>
                                <span className='event-timer'>
                  <Timer date={events?.start_draw}/>
                </span>
                            </>}
                            {location.pathname === '/'
                                ? <button className='event-button' onClick={() => navigate('/event/about')}>
                                    {events && isEventFinished ? 'Результаты' : 'Участвовать'}
                                </button> : eventFinished ?
                                    <button className='event-button active' onClick={handleShowRes}>Результаты</button>
                                    : <button className='event-button active' onClick={() => {
                                        navigate('/event/apply')
                                    }}>Загрузить фото</button>
                            }
                        </div>
                    </div>
                    <div>
                        <img className='event-image' src={events?.preview} alt=""/>
                    </div>
                </div>
            }
        </>
    );
};

export default NewYearEvent;